//是否游客模式
export const isGuest = ()=>{
    const host = window.location.host;
    return host.includes('open');
}
